module.exports = __webpack_public_path__ + "img/ETHNIC NECKLACE BN.60ef684.svg";